module.exports = __webpack_public_path__ + "static/media/left-arrow.7ce08190.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/left-arrow.svg
// module id = 51
// module chunks = 0